import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accessDenied: false,
  isInactive: false
};

const appSlice = createSlice({
  name: 'app',
  initialState: initialState,
  reducers: {
    handleInvalidToken: (state, action) => {
      state.accessDenied = action.payload;
    },
    setIsInactive: (state, action) => {
      state.isInactive = action.payload;
    }
  },
  
});

const { reducer } = appSlice;

export const { handleInvalidToken, setIsInactive } = appSlice.actions;

export const appSelector = (state) => state?.app;

export default reducer;
